export const provinceList = [
  { name: "Alberta", frenchName: "Alberta", code: "AB" },
  { name: "British Columbia", frenchName: "Colombie-Britannique", code: "BC" },
  { name: "Manitoba", frenchName: "Manitoba", code: "MB" },
  { name: "New Brunswick", frenchName: "Nouveau-Brunswick", code: "NB" },
  { name: "Newfoundland and Labrador", frenchName: "Terre-Neuve-et-Labrador", code: "NL" },
  { name: "Northwest Territories", frenchName: "Territoires du Nord-Ouest", code: "NT" },
  { name: "Nova Scotia", frenchName: "Nouvelle-Écosse", code: "NS" },
  { name: "Nunavut", frenchName: "Nunavut", code: "NU" },
  { name: "Ontario", frenchName: "Ontario", code: "ON" },
  { name: "Prince Edward Island", frenchName: "Île-du-Prince-Édouard", code: "PE" },
  { name: "Quebec", frenchName: "Québec", code: "QC" },
  { name: "Saskatchewan", frenchName: "Saskatchewan", code: "SK" },
  { name: "Yukon", frenchName: "Yukon", code: "YT" },
]
